import { styled } from 'styletron-react'
import { media } from '../../style'
import { padding, margin } from 'lostyle'

export const Row = styled('div', (props) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  ...margin({ bottom: '25px' }),
  ...media('tablet', {
    flexDirection: 'row',
    ...margin({ bottom: '30px' }),
  })
}))
Row.displayName = 'ContentBlock.Row'

export const Title = styled('div', ({ thin }) => ({
  fontSize: '24px',
  fontWeight: thin ? '500' : '600',
  width: '100%',
  ...media('tablet', {
    width: '33.33333%',
    fontSize: thin ? '24px' : '30px',
  }),
}))
Title.displayName = 'ContentBlock.Title'

export const TitleLink = styled('a', (props) => ({
  textDecoration: 'none',
  fontWeight: '500',
  borderBottom: '1px dashed',
  color: 'hsl(300,70%,75%)',
  ':hover': {
    color: 'hsl(300,70%,55%)',
  },
  cursor: 'pointer',
}))
TitleLink.displayName = 'ContentBlock.TitleLink'

export const Content = styled('div', (props) => ({
  width: '100%',
  marginTop: '10px',
  lineHeight: '1.5',
  ...media('tablet', {
    width: '66.66666%',
    marginTop: '0',
  })
}))
Content.displayName = 'ContentBlock.Content'


// WEBPACK FOOTER //
// ./src/common/ContentBlock/styles.js